// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"40":"6f5e53d9e982c1b2b74e","523":"50202ca76ae8e036b21b","906":"c4469cfa6ff1b83afe00","975":"96264d9d90182328c7a1"}[chunkId] + ".min.js";
};